import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';
import { IHintShortcutGroup } from '@shared/dto/hint_shortcuts/i_hint_shortcut_group';
import { Fragment } from 'react/jsx-runtime';
import { use_all_hints_shortcuts_columns } from './_hooks/use_all_hints_shortcuts_columns';
import { ViewAllHintsShortcutsColumnSeparator } from './ViewAllHintsShortcutsColumnSeparator';
import { ViewAllHintsShortcutsGroup } from './ViewAllHintsShortcutsGroup';
import { ViewAllHintsShortcutsGroupSeparator } from './ViewAllHintsShortcutsGroupSeparator';

export function ViewAllHintsShortcuts() {
  const dispatch = use_dispatch();
  const { hints_shortcut_overlay_with_all_values_visible } = use_slice_ui(['hints_shortcut_overlay_with_all_values_visible']);

  const columns_data = use_all_hints_shortcuts_columns();

  /*
   * EVENTS
   */

  /*
   * EFFECTS
   */

  /*
   * METHODS
   */

  function close_view() {
    dispatch(LOCAL__ui_set_boolean({ key: 'hints_shortcut_overlay_with_all_values_visible', value: false }));
  }

  /*
   * RENDERS
   */

  function render_column_groups(items: IHintShortcutGroup[]) {
    return (
      <>
        {items.map((item, index) => {
          let out = <ViewAllHintsShortcutsGroup {...{ item }} />;

          if (index < items.length - 1) {
            out = (
              <>
                {out}
                <ViewAllHintsShortcutsGroupSeparator />
              </>
            );
          }

          out = <Fragment key={`all_hints_shortcut_group_item_${item.group}`}>{out}</Fragment>;

          return out;
        })}
      </>
    );
  }

  function render_columns() {
    return columns_data.map((items_in_column, index) => {
      let out = <></>;

      const groups_in_column = render_column_groups(items_in_column);

      out = <div className="flex flex-col gap-4">{groups_in_column}</div>;

      if (index < columns_data.length - 1) {
        out = (
          <>
            {out}
            <ViewAllHintsShortcutsColumnSeparator />
          </>
        );
      }

      return <Fragment key={`column_${index}`}>{out}</Fragment>;
    });
  }

  /*
   * HTML
   */

  if (!hints_shortcut_overlay_with_all_values_visible) return null;

  return (
    <div
      onClick={close_view}
      className="
        absolute inset-0 z-[120] 
        flex-center
        bg-black bg-opacity-50
        cursor-close
      "
    >
      <div
        className="
          bg-bar 
          border border-bar-border rounded-lg
          w-[80vw] h-[85vh]
          cursor-close
          flex flex-col
          overflow-hidden
        "
      >
        <div className={`h-full py-6 px-8 overflow-y-auto grid grid-cols-[1fr_1px_1fr_1px_1fr] gap-6`}>{render_columns()}</div>
      </div>
    </div>
  );
}
